import type { LicensedProducts } from '@atlassian/jira-shared-types/src/tenant-context.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useLicensedProducts = (): LicensedProducts => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.licensedProducts) || {};
};
